module.exports = __webpack_public_path__ + "static/d1_large-3a552b5ccadb88c4e7ed0f2f54185746.jpg";